export const SEARCH_RFS_ASYNC = 'SEARCH_RFS_ASYNC';
export const SEARCH_RFS_SUCCESS = 'SEARCH_RFS_SUCCESS';
export const AWAITING_REVIEW_RFS_ASYNC = 'AWAITING_REVIEW_RFS_ASYNC';
export const APPROVE_RFS_ASYNC = 'APPROVE_RFS_ASYNC';
export const CLOSE_RFS_ASYNC = 'CLOSE_RFS_ASYNC';
export const GET_BY_RFS_ID_ASYNC = 'GET_BY_RFS_ID_ASYNC';
export const GET_BY_RFS_ID_SUCCESS = 'GET_BY_RFS_ID_SUCCESS';
export const ADD_EDIT_RFS_ERROR = 'ADD_EDIT_RFS_ERROR';
export const RESET_RFS = 'RESET_RFS';
export const RESET_RFS_INFO = 'RESET_RFS_INFO';
export const ADD_RFS = 'ADD_RFS';
export const ADD_RFS_SUCCESS = 'ADD_RFS_SUCCESS';
export const ADD_RFS_FAILED = 'ADD_RFS_FAILED';
export const GET_LIST_WORK_ORDER_BY_RFSID_ASYNC =
  'GET_LIST_WORK_ORDER_BY_RFSID_ASYNC';
export const GET_LIST_WORK_ORDER_BY_RFSID_SUCCESS =
  'GET_LIST_WORK_ORDER_BY_RFSID_SUCCESS';
export const SIGNOFF_MULTIPLE_WORK_ORDER_ASYNC =
  'SIGNOFF_MULTIPLE_WORK_ORDER_ASYNC';
export const GET_RFS_HISTORY_ASYNC = 'GET_RFS_HISTORY_ASYNC';
export const GET_RFS_HISTORY_SUCCESS = 'GET_RFS_HISTORY_SUCCESS';
export const UPDATE_RFS_WITHOUT_CHANGE_STATUS_ASYNC =
  'UPDATE_RFS_WITHOUT_CHANGE_STATUS_ASYNC';
export const UPDATE_RFS_MANAGE_BY_ASYNC = 'UPDATE_RFS_MANAGE_BY_ASYNC';

export const UPDATE_RFS_REQUEST_TYPE_ASYNC = 'UPDATE_RFS_REQUEST_TYPE_ASYNC';

//Report select list
export const REPORT_SELECT_LIST_REGION_ASYNC =
  'REPORT_SELECT_LIST_REGION_ASYNC';
export const REPORT_SELECT_LIST_REGION_SUCCESS =
  'REPORT_SELECT_LIST_REGION_SUCCESS';
export const REPORT_SELECT_LIST_MARKET_ASYNC =
  'REPORT_SELECT_LIST_MARKET_ASYNC';
export const REPORT_SELECT_LIST_MARKET_SUCCESS =
  'REPORT_SELECT_LIST_MARKET_SUCCESS';
export const REPORT_SELECT_LIST_PROJECT_ASYNC =
  'REPORT_SELECT_LIST_PROJECT_ASYNC';
export const REPORT_SELECT_LIST_PROJECT_SUCCESS =
  'REPORT_SELECT_LIST_PROJECT_SUCCESS';
export const REPORT_SELECT_LIST_REQUEST_TYPE_ASYNC =
  'REPORT_SELECT_LIST_REQUEST_TYPE_ASYNC';
export const REPORT_SELECT_LIST_REQUEST_TYPE_SUCCESS =
  'REPORT_SELECT_LIST_REQUEST_TYPE_SUCCESS';
export const REPORT_SELECT_LIST_LOT_ASYNC = 'REPORT_SELECT_LIST_LOT_ASYNC';
export const REPORT_SELECT_LIST_LOT_SUCCESS = 'REPORT_SELECT_LIST_LOT_SUCCESS';

// HOMEOWNER
export const HOMEOWNER_ADD_REQUEST_ASYNC = 'HOMEOWNER_ADD_REQUEST_ASYNC';
export const SIGNOFF_MULTIPLE_HOMEOWNER_WORK_ORDER_ASYNC =
  'SIGNOFF_MULTIPLE_HOMEOWNER_WORK_ORDER_ASYNC';

// PRINT PREVIEW RFS
// export const PRINT_PREVIEW_SUBCONTRACTOR_RFS_ASYNC = 'PRINT_PREVIEW_SUBCONTRACTOR_RFS_ASYNC';
// export const PRINT_PREVIEW_HOMEOWNER_RFS_ASYNC = 'PRINT_PREVIEW_HOMEOWNER_RFS_ASYNC';
export const PRINT_PREVIEW_RFS_ASYNC = 'PRINT_PREVIEW_RFS_ASYNC';

// SCHEDULE REQUEST
export const ADD_SCHEDULE_RFS_ASYNC = 'ADD_SCHEDULE_RFS_ASYNC';
export const ADD_SCHEDULE_RFS_SUCCESS = 'ADD_SCHEDULE_RFS_SUCCESS';
export const ADD_SCHEDULE_RFS_FAIL = 'ADD_SCHEDULE_RFS_FAIL';

export const EXPORT_RFS_LIST = 'EXPORT_RFS_LIST';

export const REASSIGN_MULTIPLE_RFS_ASYNC = 'REASSIGN_MULTIPLE_RFS_ASYNC';
export const REASSIGN_MULTIPLE_RFS_SUCCESS = 'REASSIGN_MULTIPLE_RFS_SUCCESS';

export const GET_EOC_DETAIL_ASYNC = 'GET_EOC_DETAIL_ASYNC';
export const GET_EOC_DETAIL_SUCCESS = 'GET_EOC_DETAIL_SUCCESS';

export const PRINT_EOC_TEMPLATE_ASYNC = 'PRINT_EOC_TEMPLATE_ASYNC';
export const PRINT_EOF_TEMPLATE_ASYNC = 'PRINT_EOF_TEMPLATE_ASYNC';
export const PRINT_EPL_TEMPLATE_ASYNC = 'PRINT_EPL_TEMPLATE_ASYNC';

export const REQUEST_SIGNATURE_ASYNC = 'REQUEST_SIGNATURE_ASYNC';

export const REQUEST_CHECKLISTS_SIGNATURE_ASYNC = 'REQUEST_CHECKLISTS_SIGNATURE_ASYNC';

export const REQUEST_CHECKLISTS_APPROVAL_ASYNC = 'REQUEST_CHECKLISTS_APPROVAL_ASYNC';

export const SUBMIT_EOC_LIST_ASYNC = 'SUBMIT_EOC_LIST_ASYNC';

export const EOC_TEMPLATE_HOMEOWNER_ASYNC = 'EOC_TEMPLATE_HOMEOWNER_ASYNC';
export const EOC_TEMPLATE_HOMEOWNER_SUCCESS = 'EOC_TEMPLATE_HOMEOWNER_SUCCESS';

export const GET_GLOBAL_ENDPOINT_RFS_ASYNC = 'GET_GLOBAL_ENDPOINT_RFS_ASYNC';
export const GET_GLOBAL_ENDPOINT_RFS_SUCCESS = 'GET_GLOBAL_ENDPOINT_RFS_SUCCESS';

export const EOC_SUBMIT_TEMPLATE_HOMEOWNER_ASYNC = 'EOC_SUBMIT_TEMPLATE_HOMEOWNER_ASYNC';

export const HOMEOWNER_RFS_SETUP_AWS_ASYNC = 'HOMEOWNER_RFS_SETUP_AWS_ASYNC';
export const HOMEOWNER_RFS_SETUP_AWS_SUCCESS = 'HOMEOWNER_RFS_SETUP_AWS_SUCCESS';

export const SETUP_RFS_UPLOAD_SIGNATURE_S3 = 'SETUP_RFS_UPLOAD_SIGNATURE_S3';

export const SAVE_EOC_TEMPLATE_TO_LOT_DOCUMENT_ASYNC = 'SAVE_EOC_TEMPLATE_TO_LOT_DOCUMENT_ASYNC';

export const SEND_EOC_TEMPLATE_EMAIL_ASYNC = 'SEND_EOC_TEMPLATE_EMAIL_ASYNC';

export const GET_EMAIL_PRIMARY_HOMEOWNER_ASYNC = 'GET_EMAIL_PRIMARY_HOMEOWNER_ASYNC';
export const GET_EMAIL_PRIMARY_HOMEOWNER_SUCCESS = 'GET_EMAIL_PRIMARY_HOMEOWNER_SUCCESS';

export const GET_EPL_DETAIL_ASYNC = 'GET_EPL_DETAIL_ASYNC';
export const GET_EPL_IS_AVAILABLE_ASYNC = 'GET_EPL_IS_AVAILABLE_ASYNC';

export const GET_EPL_DETAIL_SUCCESS = 'GET_EPL_DETAIL_SUCCESS';

export const SUBMIT_EPL_LIST_ASYNC = 'SUBMIT_EPL_LIST_ASYNC';
export const SEND_EPL_TEMPLATE_EMAIL_ASYNC = 'SEND_EPL_TEMPLATE_EMAIL_ASYNC';
export const FETCH_CREATED_BY_RFS = 'FETCH_CREATED_BY_RFS';
export const FETCH_CREATED_BY_RFS_SUCCESS = 'FETCH_CREATED_BY_RFS_SUCCESS';
export const FILTER_WO = "FILTER_WO";
export const FILTER_WO_SUCCESS = "FILTER_WO_SUCCESS";
export const UPDATED_FILTER_VALUE_FOR_WO = "UPDATED_FILTER_VALUE_FOR_WO"
export const UPDATED_FILTER_VALUE_FOR_WO_SUCCESS = "UPDATED_FILTER_VALUE_FOR_WO_SUCCESS"
export const UPDATE_WO_RASSIGN_VALUE = "UPDATE_WO_RASSIGN_VALUE";
export const UPDATE_WO_RASSIGN_VALUE_SUCCESS = "UPDATE_WO_RASSIGN_VALUE_SUCCESS";
export const PREVIEW_WO_LIST = "PREVIEW_WO_LIST"
export const FILTER_PREVIEW_WO_SUCCESS = "FILTER_PREVIEW_WO_SUCCESS";
export const FETCH_AVERAGE_AGE_OF_RFS = 'FETCH_AVERAGE_AGE_OF_RFS';
export const FETCH_AVERAGE_AGE_OF_RFS_SUCCESS = "FETCH_AVERAGE_AGE_OF_RFS_SUCCESS";
export const GET_RFS_REVIEW_DATE = "GET_RFS_REVIEW_DATE"
export const GET_RFS_REVIEW_DATE_SUCCESS = "GET_RFS_REVIEW_DATE_SUCCESS"



// WEBPACK FOOTER //
// ./src/Request-Services/constants.js